import './VehiclesCatalog.css';const vehiclesCatalog = "_vehiclesCatalog_2uz3a_1";
const vehiclesCatalog__buttonCol = "_vehiclesCatalog__buttonCol_2uz3a_5";
const styles = {
  vehiclesCatalog,
  vehiclesCatalog__buttonCol
};
export {
  styles as default,
  vehiclesCatalog,
  vehiclesCatalog__buttonCol
};
